/**
 * True for a non-null, non-array object (a record-like value); false for `null`,
 * arrays, and primitives.
 *
 * Handy for guarding option-bag payloads (e.g. the `core.setSize()` /
 * `core.setPosition()` arguments): TypeScript forbids a non-object argument, but
 * a plain-JS caller can still pass `null`, a scalar, or an array. Callers that
 * dereference named keys would otherwise throw on `null`/scalars or silently
 * process an array as an empty record — this lets them ignore malformed input
 * instead.
 */
export const isObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);
